export class Visible{
	init(){
		var elem = $('.features-list__item, .text, .mini-gallery__item, .articles-list__item, .download-files__item');

		elem.each(function() {
			var $this = $(this),
				elemVisible = $this.visible(true, 'vertical');

			if(elemVisible)
				$this.addClass('on-screen', elemVisible);
		});


		$(window).scroll(function() {
			elem.each(function() {
				var $this = $(this),
					elemVisible = $this.visible(true, 'vertical');

				if(elemVisible)
					$this.addClass('on-screen', elemVisible);
			});
		});
		
		this.delay($('.features-list--link-box .features-list__item'));
		// this.delay($('.articles-list--news .articles-list__item'));
	}
	delay(elem){
		elem.each(function(index) {
			$(this).css('transition-delay', 100*index + 'ms');
		});
	}
}